import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Users, Bell, AlertTriangle, UserCircle, Activity, Settings, GitBranch } from 'lucide-react';
import HubspotIcon from './HubspotIcon';
const Sidebar: React.FC = () => {
  const location = useLocation();
  const menuItems = [{
    path: '/',
    label: 'Home',
    icon: <Home size={18} data-id="element-165" />
  }, {
    path: '/sequences',
    label: 'Sequences',
    icon: <GitBranch size={18} data-id="element-166" />
  }, {
    path: '/alerts',
    label: 'Alerts',
    icon: <AlertTriangle size={18} data-id="element-167" />
  }, {
    path: '/actions',
    label: 'Actions',
    icon: <Activity size={18} data-id="element-168" />
  }, {
    path: '/personas',
    label: 'Personas',
    icon: <UserCircle size={18} data-id="element-169" />
  }, {
    path: '/accounts',
    label: 'Accounts',
    icon: <Bell size={18} data-id="element-170" />
  }, {
    path: '/users',
    label: 'Users',
    icon: <Users size={18} data-id="element-171" />
  }, {
    path: '/hubspot',
    label: 'HubSpot',
    icon: <HubspotIcon size={18} data-id="element-172" />
  }];
  return <div className="w-[210px] bg-[#0047A3] text-white flex flex-col h-full" data-id="element-173">
      <div className="p-4 pb-6" data-id="element-174">
        <h1 className="text-xl font-bold" data-id="element-175">Daemo</h1>
      </div>
      <nav className="flex-1" data-id="element-176">
        <ul className="space-y-1" data-id="element-177">
          {menuItems.map(item => <li key={item.path} data-id="element-178">
              <Link to={item.path} className={`flex items-center gap-3 px-4 py-2.5 ${location.pathname === item.path || location.pathname.startsWith(`${item.path}/`) ? 'bg-[#0057a3] text-white' : 'text-white/80 hover:bg-[#0057a3]'}`} data-id="element-179">
                {item.icon}
                <span className="text-sm" data-id="element-180">{item.label}</span>
              </Link>
            </li>)}
        </ul>
      </nav>
      <div className="p-4" data-id="element-181">
        <Link to="/settings" className={`flex items-center gap-3 px-4 py-2.5 ${location.pathname === '/settings' ? 'bg-[#0057a3] text-white' : 'text-white/80 hover:bg-[#0057a3]'}`} data-id="element-182">
          <Settings size={18} data-id="element-183" />
          <span className="text-sm" data-id="element-184">Settings</span>
        </Link>
      </div>
    </div>;
};
export default Sidebar;